document.addEventListener("alpine:init", () => {
  Alpine.data("blog", () => ({
    blogDomain: "https://paschachocolate.com",
    blogData: {},
    articlesData: [],
    blogFilters: {
      cacaoPercentage: "",
      madeWith: "",
      dietary: "",
      categories: "",
    },
    selectedFilters: [],
    showNotFoundMessage: false,
    blogPage: 1,
    articlesPerPage: 9,
    pagesCount: null,
    sectionHeading: "",

    init() {
      if (window.location.href.includes(":9292")) {
        this.blogDomain = "http://127.0.0.1:9292";
      }

      this.sectionHeading = this.$root.dataset.sectionHeading;

      this.$watch("blogFilters", () => {
        this.selectedFilters = [
          this.blogFilters.dietary,
          this.blogFilters.madeWith,
          this.blogFilters.cacaoPercentage,
          this.blogFilters.categories,
        ];

        this.blogPage = 1;
        this.fetchBlogData();
      });
      this.$watch("blogPage", () => {
        this.fetchBlogData();
      });

      this.fetchBlogData();
    },
    async fetchBlogData() {
      let tagsStrURL = "";

      for (const [index, filter] of this.selectedFilters.entries()) {
        if (filter !== "") {
          tagsStrURL = "tagged/";
          break;
        }
      }

      if (this.selectedFilters.length > 0) {
        for (const [index, filter] of this.selectedFilters.entries()) {
          if (filter !== "") {
            tagsStrURL = tagsStrURL + filter + "+";

            if (index === -1) {
              tagsStrURL = tagsStrURL + "/";
            }

            tagsStrURL = tagsStrURL.replace(" ", "-").replace("%", "");
          }
        }
      }

      const fetchUrl = `${this.blogDomain}/blogs/recipes/${tagsStrURL}?view=json-feed&page=${this.blogPage}`;

      await fetch(fetchUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            this.showNotFoundMessage = true;

            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          const blogData = data;
          console.log("Blog data received:", blogData.entries);
          this.blogData = blogData.feed;
          this.articlesData = blogData.entries;
          this.pagesCount = blogData.feed.blogPages;

          this.showNotFoundMessage = false;
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    },
    resetBlogFilters() {
      this.blogFilters.dietary = "";
      this.blogFilters.madeWith = "";
      this.blogFilters.cacaoPercentage = "";
      this.blogFilters.categories = "";

      this.selectedFilters = [];

      this.$dispatch("filters_reset");
    },
    get currentArticles() {
      const start = (this.blogPage - 1) * this.articlesPerPage;
      return this.articlesData.slice(start, start + this.articlesPerPage);
    },
    get startPage() {
      return Math.max(2, this.blogPage - 2);
    },

    get endPage() {
      return Math.min(this.pagesCount - 1, this.blogPage + 2);
    },
    get middlePages() {
      let pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        if (i > 1 && i < this.pagesCount) {
          pages.push(i);
        }
      }
      return pages;
    },
  }));
});
